import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

const LEVELS_KEY = ["levels"];
const STUDENTS_KEY = ["academy-students"];

// ── Proficiency levels (owner CRUD; list also for teachers) ──────────────────
function useLevels() {
  return useQuery({
    queryKey: LEVELS_KEY,
    queryFn: () => apiClient.get("/api/v1/levels/").then((r) => r.data),
  });
}

function useCreateLevel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => apiClient.post("/api/v1/levels/", body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: LEVELS_KEY }),
  });
}

function useUpdateLevel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) =>
      apiClient.patch(`/api/v1/levels/${id}/`, body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: LEVELS_KEY }),
  });
}

function useDeleteLevel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiClient.delete(`/api/v1/levels/${id}/`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: LEVELS_KEY });
      qc.invalidateQueries({ queryKey: STUDENTS_KEY });
    },
  });
}

// ── Students (owner list) + level assignment (owner/teacher) ─────────────────
function useAcademyStudents() {
  return useQuery({
    queryKey: STUDENTS_KEY,
    // Empty query returns all students (with horas contratadas + saldo + level).
    queryFn: () => apiClient.get("/api/v1/students/search/").then((r) => r.data),
  });
}

function useSetStudentLevel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ studentId, levelId }) =>
      apiClient
        .patch(`/api/v1/students/${studentId}/level/`, { level_id: levelId })
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: STUDENTS_KEY });
      qc.invalidateQueries({ queryKey: ["teacher", "student-search"] });
    },
  });
}

export {
  useLevels,
  useCreateLevel,
  useUpdateLevel,
  useDeleteLevel,
  useAcademyStudents,
  useSetStudentLevel,
};
